import React from 'react';
import { useSelector } from 'react-redux';

const PackageHeader = ({packageDetails}) => {
    const culture = useSelector((state) => state.culture.currentCulture);
    const lang = useSelector((state) => state.culture.language);
    
    return (
        <>
            <section className="inner_banner spackagedtlsHead">
                <div className="container">
                    <div className="row align-items-center">
                    <div className="col-lg-6 col-md-10 col-9 ">
                        <div className="title_sec_content">
                        <div className="mob_backArrow desk_hide" />
                        <div className="htlDtls_topDtls">
                            <h2> {packageDetails?.BasicInfo?.Country[0]?.Name}</h2>
                            <p>{packageDetails?.BasicInfo?.Description}{packageDetails?.BasicInfo?.Location && ','} {packageDetails?.BasicInfo?.Location}</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-2 col-3 d-flex justify-content-end mob_pad">
                        <button onClick={() => window.location.href = process.env.REACT_APP_BASE_URL + culture +"/package-result"} className=" backBtn">&lt; {lang.back}</button>
                    </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default PackageHeader;
